/**
 * English messages (source of truth for the Messages shape).
 *
 * Other locales must satisfy `Messages` (see ../types.ts), which guarantees
 * every key is present and spelled correctly at compile time.
 */
export const en = {
  // Shown above every surface. Rendered uppercase via CSS, so the stored
  // string stays sentence-case for locales where all-caps is not idiomatic.
  advertisement: {
    label: "Advertisement",
  },
  pill: {
    // One copy at every position (APPS-5583): the floating pill names the
    // destination too, folding onto a second line rather than dropping it.
    cta: "Place a prediction through Predictor.io",
    // Commas, not a dash: the visible text has to read back unbroken inside
    // the accessible name (WCAG 2.5.3).
    ariaLabel: "Place a prediction through Predictor.io, open preview",
  },
  preview: {
    subtitle: "Place a prediction through Predictor.io",
    ctaMultiChoice: "Details",
    ctaAriaLabel: "Open full market details",
    closeAriaLabel: "Close preview",
  },
  outcomes: {
    yes: "Yes",
    no: "No",
  },
  card: {
    // The control is a down chevron: it collapses the card back to the
    // preview rather than dismissing the widget.
    minimiseAriaLabel: "Minimise market details",
    brand: "Predictor.io",
    // Split so the brand reads bold against regular body text, the same
    // lead/bold/rest shape the compliance paragraphs below use.
    advertisementSource: {
      lead: "The information presented in this advertisement is from ",
      bold: "Predictor.io",
      rest: ".",
    },
    timeLeftLabel: "{value} left",
    timeLeftDays: "{count} days",
    timeLeftDay: "{count} day",
    seeAllOptions: "See all options",
    ctaPredict: "Predict on Predictor.io",
    outcomeVolume: "{value} volume",
    outcomePriceChange: "{value}% today",
    compliance: {
      shortLabel: "Registered IB (CFTC/NFA)",
      title: "Regulatory Information",
      paragraph1Lead: "This content is provided for ",
      paragraph1Bold: "informational and educational purposes",
      paragraph1Rest:
        " only and does not constitute investment advice or a solicitation to trade.",
      paragraph2Bold: "Predictor LLC",
      paragraph2Rest:
        " is a registered Introducing Broker with the U.S. Commodity Futures Trading Commission (CFTC) and a Member of the National Futures Association (NFA).",
      paragraph3Bold: "Trading involves risk",
      paragraph3Rest:
        " and may result in loss. Past performance is not indicative of future results.",
    },
  },
} as const;
